import HttpService from "../../../services/HttpService";

export const fetchCourseListDetails = () => HttpService.get('/club/course_details/')


export const fetchYardDetails = (courseId) =>
  HttpService.get(`/club/hole_details/?course_id=${courseId}`);

export const saveYardDetails = (yards_and_par_data) =>
  HttpService.post(`/club/hole_details/`, yards_and_par_data);

export const updateYardDetails = (yards_and_par_data) =>
  HttpService.put(`/club/hole_details/`, yards_and_par_data);